import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import { PickList, PickListModule } from 'primeng/picklist';
import { Tag } from '../../../models/tag';
import { TagStore } from '../../../stores/tag/tag.state';
import { DividerModule } from 'primeng/divider';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TagFilterComponent } from '../tag-filter/tag-filter.component';

@Component({
  selector: 'app-tag-pick-list',
  standalone: true,
  imports: [
    DividerModule,
    NgIf,
    PickListModule,
    SharedModule,
    TagFilterComponent,
  ],
  templateUrl: './tag-pick-list.component.html',
  styleUrl: './tag-pick-list.component.scss',
})
export class TagPickListComponent {
  @ViewChild('listPickerCtrl') listPickerCtrl!: PickList;
  @Input() ignoreChildren = false;
  @Input() showSourceControls = false;
  @Input() showTargetControls = true;

  readonly tagStore = inject(TagStore);

  selected: Tag[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  /**
   * Updates the current selection in the tag store with the specified selection.
   *
   * @return {void} Does not return a value.
   */
  updateSelection(): void {
    this.tagStore.updateSelection(this.selected);
  }
}
